import { css } from "@emotion/css";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type { PropsWithChildren } from "react";
import React from "react";
import Chip from "~/components/Chips/Chip";
import { ExpandableFormSection, Summary } from "~/components/form/index";
export type DelegatedFromSectionProps = {
    title: React.ReactNode;
    errorKey: string;
    help?: React.ReactNode;
    isExpandedByDefault?: boolean;
    accessibleName: string;
    contextualHelp?: React.ReactNode;
};
function DelegatedFormSection({ title, errorKey, help, isExpandedByDefault, children, accessibleName }: PropsWithChildren<DelegatedFromSectionProps>) {
    const summary = Summary.placeholder("(To be specified in project)");
    const helpInternal = (<div>
            <span className={styles.disabledHelp}>{help}</span>
            {<Chip>Project-specific</Chip>}
        </div>);
    return (<div className={styles.disabledHelp}>
            <ExpandableFormSection title={title} isExpandedByDefault={isExpandedByDefault} errorKey={errorKey} summary={summary} help={helpInternal} accessibleName={accessibleName}>
                {children}
            </ExpandableFormSection>
        </div>);
}
const styles = {
    disabledHelp: css({
        color: `${themeTokens.color.text.disabled} !important`,
    }),
};
export default DelegatedFormSection;
